if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends HTMLElement {
      constructor() {
        super();
        this.lastScroll = 0;
        this.threshold = 10; // حساسية السكرول
      }

      connectedCallback() {
        this.init();
      }

      init() {
        // إعطاء إشارة للـ CSS بأن الـ JS جاهز ليظهر السكشن
        setTimeout(() => {
          this.setAttribute('loaded', '');
          this.setHeight();
        }, 100);

        // مراقبة السكرول للإخفاء والإظهار الذكي
        window.addEventListener('scroll', () => this.onScroll(), { passive: true });
        
        // تحديث الارتفاع عند تغيير حجم الشاشة
        window.addEventListener('resize', () => this.setHeight());

        // دعم الـ Shopify Design Mode (المعاينة في الداشبورد)
        if (Shopify.designMode) {
          this.addEventListener('shopify:section:select', () => this.classList.remove('dock-hidden'));
        }
      }

      onScroll() {
        const currentScroll = window.pageYOffset;
        
        // إذا كان السكرول في قمة الصفحة، أظهره دائماً
        if (currentScroll <= 0) {
          this.classList.remove('dock-hidden');
          return;
        }

        // حساب الفرق بين السكرول الحالي والسابق
        const scrollDelta = currentScroll - this.lastScroll;

        if (Math.abs(scrollDelta) > this.threshold) {
          if (scrollDelta > 0 && !this.classList.contains('dock-hidden')) {
            // سكرول لأسفل -> إخفاء
            this.classList.add('dock-hidden');
          } else if (scrollDelta < 0 && this.classList.contains('dock-hidden')) {
            // سكرول لأعلى -> إظهار
            this.classList.remove('dock-hidden');
          }
          this.lastScroll = currentScroll;
        }
      }

      setHeight() {
        // تحديد ارتفاع السكشن لإضافة مساحة (padding) في أسفل الموقع
        const height = this.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--mobile-dock-height', `${height.toFixed(1)}px`);
      }
    }
  );
}